import axios from "axios";

export default axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  headers: {'Authorization': `apikey ${process.env.REACT_APP_API_KEY}`, 'content-type': 'application/ld+json'}
});
